"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WarningMessageStyled = exports.IconStyled = exports.GracePeriodErrorStyled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _BreakPoints = require("../../styles/BreakPoints");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var GracePeriodErrorStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__grace-period-error'
  };
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  background-color: #ffd0d7;\n  border: 1px solid #edb8c0;\n  border-radius: 12px;\n  padding: 14px 26px 15px 0;\n  text-align: left;\n  font-size: 11px;\n  color: #515364;\n  font-family: 'Open Sans', sans-serif;\n  line-height: 17px;\n  letter-spacing: 0.28px;\n  margin-bottom: 38px;\n  ", "\n"])), _BreakPoints.media.small(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    border-radius: 0;\n    margin: -55px -46px 32px;\n    font-size: 10px;\n    line-height: 16px;\n    letter-spacing: 0.25px;\n  "]))));
exports.GracePeriodErrorStyled = GracePeriodErrorStyled;
var WarningMessageStyled = _styledComponents.default.span.attrs(function () {
  return {
    className: 'msd__grace-period-error-warning'
  };
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  text-decoration: underline;\n  font-weight: bold;\n"])));
exports.WarningMessageStyled = WarningMessageStyled;
var IconStyled = _styledComponents.default.div.attrs(function () {
  return {
    className: 'msd__grace-period-error-alert-icon'
  };
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  padding-left: 23px;\n"])));
exports.IconStyled = IconStyled;